import { DailyProductionCard } from "./DailyProductionCard";
export default DailyProductionCard;
